import { render } from "./CreatePasskey.vue?vue&type=template&id=b9db0fce"
import script from "./CreatePasskey.vue?vue&type=script&lang=js"
export * from "./CreatePasskey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__